export default function CredentialsEvaluation() {
  return (
    <main className="container">
      <div className="row my-5">
        <div className="col"></div>

        <div className="col-sm-12 col-md-7">
          <h1 className="fs-3 pb-4">How are credentials evaluated?</h1>

          <p>
            The Democracy, Straight-Up! Project does not decide whether you are
            qualified to participate in your district's legislature.
            Your fellow legislators do.
          </p>

          <p>
            When you seek admission to a Circle, you will provide information
            that allows its members to evaluate your claim that you are a legal
            voter in the district.
          </p>

          <p>
            Circle members may consider the information you provide, their
            personal knowledge of you, publicly available information, or any
            other evidence they consider appropriate.
          </p>

          <p>
            Registration is not a requirement imposed by the Portal. The
            members themselves decide whether your credentials are sufficient
            for admission.
          </p>

          <p>
            A person who creates a new Circle is admitted provisionally on
            their own attestation. As other members join, they may evaluate the
            founder's credentials just as they evaluate one another's.
          </p>

          <p>
            DSUp provides the machinery for the legislature. It does not possess
            the power of admission.
          </p>
        </div>

        <div className="col"></div>
      </div>
    </main>
  );
}